import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/layout.css";
import authService from "../services/auth/authService";

/**
 * Menu latéral de l'ERP unifié : le CRM et la gestion du Lab, côte à côte.
 *
 * Chaque rôle ne voit que ce qu'il peut réellement ouvrir. Ce filtrage est du
 * confort, pas de la sécurité : la vraie autorisation vit dans
 * backend/core/permissions.py. Il évite simplement qu'un apprenant clique sur
 * « Salles » pour tomber sur un 403.
 */
function Sidebar({ ouverte = false, onFermer }) {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const estGestion     = authService.isGestion();
  const estCommercial  = authService.isCommercial();
  const estPedagogique = authService.isPedagogique();
  const estApprenant   = authService.isApprenant();

  const lien = (to, icone, libelle) => (
    <Link to={to} className={`sidebar-link ${isActive(to) ? "active" : ""}`}>
      <i className={`fa-solid ${icone}`}></i>
      {libelle}
    </Link>
  );

  return (
    <aside className={`sidebar ${ouverte ? "ouverte" : ""}`} onClick={(e) => { if (e.target.closest("a")) onFermer?.(); }}>
      <Link to="/home" className={`sidebar-home-link ${isActive("/home") ? "active" : ""}`}>
        <i className="fa-solid fa-house"></i>
        <span>Home</span>
      </Link>

      {/* Le scoring IA porte sur les prospects : réservé au commercial. */}
      {estCommercial && (
        <>
          <div className="sidebar-title">AIDE À LA DÉCISION</div>
          {lien("/dashboard-scoring-ia", "fa-brain", "Dashboard Scoring IA")}
        </>
      )}

      {estCommercial && (
        <>
          <div className="sidebar-title">GESTION RELATION CLIENT</div>
          {lien("/prospects", "fa-user-plus", "Prospects")}
          {lien("/etudiants", "fa-user-graduate", "Étudiants")}
          {lien("/diplomes", "fa-award", "Attestés")}
          {lien("/marketing-mail", "fa-envelope", "Marketing Mail")}
        </>
      )}

      {/* L'offre du centre est réservée à l'équipe (demande de l'équipe) : ni
          étudiant ni formateur ne la voient, leurs propres sessions sont dans
          « Mon planning ». Le serveur refuse aussi le catalogue (GereLeCatalogue). */}
      {estCommercial && (
        <>
          <div className="sidebar-title">INFORMATIONS DU CENTRE</div>
          {estGestion && lien("/formateurs", "fa-chalkboard-user", "Formateurs")}
          {lien("/formations", "fa-book-open", "Formations")}
          {lien("/session-formations", "fa-calendar-days", "Sessions de formation")}
        </>
      )}

      {/* GESTION DU LAB — l'ancien Lab Manager, désormais dans le même ERP */}
      <div className="sidebar-title">GESTION DU LAB</div>
      {/* Salles : administration seulement. Le formateur voit la salle de ses
          séances dans son planning (demande de l'équipe ; GereLesSalles). */}
      {estGestion && lien("/salles", "fa-door-open", "Salles")}
      {/* Chacun voit SON planning et SES présences : le serveur filtre (scope_*). */}
      {lien("/planning", "fa-calendar-week", estApprenant || authService.isFormateur() ? "Mon planning" : "Planning")}
      {estPedagogique && lien("/presences", "fa-clipboard-check", "Présences")}
      {estApprenant && lien("/presences", "fa-clipboard-check", "Mes présences")}
      {/* Un apprenant consulte ses notes publiées ; il ne les saisit pas.
          L'agent marketing n'y a pas accès : ce sont des données pédagogiques. */}
      {(estPedagogique || estApprenant) &&
        lien("/notes", "fa-star-half-stroke", estApprenant ? "Mes notes" : "Notes")}
      {lien("/messagerie", "fa-comments", "Messagerie")}

      <div className="sidebar-title">SYSTÈME</div>
      {lien("/mon-profil", "fa-id-badge", "Mon profil")}
      {estGestion && lien("/gestion-comptes", "fa-users", "Gestion des comptes")}
    </aside>
  );
}

export default Sidebar;
